import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  ErrorButtonContained,
  PrimaryButtonContained,
  PrimaryButtonOutlined,
} from "../../../components";
import { DeleteForever, Save, Send } from "../../../icons";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `0 ${theme.spacing(2)}px`,
    backgroundColor: theme.palette.grey[200],
    marginTop: "auto",
    marginBottom: 0,
  },
}));

function EditRecipientListControls({
  onDelete,
  onSave,
  onContinueCampaign,
  disabled,
  hasErrors,
  ...rest
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const newRecipientList = useSelector((state) => state.newRecipientList);

  return (
    <Grid
      {...rest}
      container
      spacing={2}
      alignItems="center"
      justify="flex-end"
      className={classes.root}
    >
      <Grid item>
        <ErrorButtonContained
          data-test-id="recipientList-edit-button-delete"
          startIcon={<DeleteForever />}
          onClick={onDelete}
        >
          {t("Delete")}
        </ErrorButtonContained>
      </Grid>
      <Grid item>
        <PrimaryButtonContained
          data-test-id="recipientList-edit-button-update"
          startIcon={<Save />}
          onClick={onSave}
          disabled={hasErrors || disabled}
        >
          {t("Update")}
        </PrimaryButtonContained>
      </Grid>
      {newRecipientList?.redirect && (
        <Grid item>
          <PrimaryButtonOutlined
            data-test-id="recipientList-edit-button-campaign-continue"
            startIcon={<Send />}
            onClick={onContinueCampaign}
            disabled={hasErrors || disabled}
          >
            {t("Continue Campaign")}
          </PrimaryButtonOutlined>
        </Grid>
      )}
    </Grid>
  );
}

export default memo(EditRecipientListControls);
